<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车主姓名：</span>
        </div>
        <el-input v-model="carOwnerName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">车主手机号：</span>
        </div>
        <el-input v-model="carOwnerPhone" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="carNumber" size="small" style="width: 280px" />
      </div>

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <span class="line-text">卡号：</span>-->
<!--        </div>-->
<!--        <el-input v-model="cardNumber" size="small" style="width: 280px" />-->
<!--      </div>-->


      <div class="form-line">
        <div class="textBox">
          <span class="line-text">车辆品牌：</span>
        </div>
        <el-input v-model="carBrand" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">车辆颜色：</span>
        </div>
        <el-input v-model="carColor" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">车辆型号：</span>
        </div>
        <el-input v-model="carType" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所属住户：</span>
        </div>
        <el-input v-model="enterpriseName" size="small" style="width: 280px" />
      </div>

      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">授权类型：</span>-->
        <!--</div>-->
        <!--<el-select v-model="authorizationType" size="small" style="width: 280px">-->
          <!--<el-option v-for="item in authorizationTypeList" :key="item.code"-->
                     <!--:label="item.name" :value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">进出有效期：</span>-->
<!--        </div>-->
<!--        <el-date-picker v-model="dataValue" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="center" size="small" :picker-options="pickerOptions2" value-format="yyyy-MM-dd" ></el-date-picker>-->
<!--      </div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/ParkingService'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import InputDatePicker from '../../../components/Input/InputDatePicker'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      InputDatePicker,
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'authorization-add',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧停车',
            name: 'parking-device-management'
          }, {
            value: '车辆管理'
          }],
        },
        mainTitle: '添加车辆',
        // authorizationTypeList: [
        //   {
        //     code: '0',
        //     name: '免费'
        //   }, {
        //     code: '1',
        //     name: '收费'
        //   }
        // ],
        pickerOptions2: {
          shortcuts: [{
            text: '未来一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来一年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来三年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        rentList: [],
        subheading: '',
        personName: '',
        identityNumber: '',
        workType: '',
        certificate: '',

        carNumber: '',
        cardNumber: '',
        carBrand: '',
        carColor: '',
        carOwnerName: '',
        carOwnerPhone: '',
        enterpriseName: '',
        carType: '',
        dataValue: [],
        enterStartTime: '',
        enterEndTime: '',
        bindAccountName: '',
        bindAccountCode: '',
        bindType: '1'
      }
    },
    created () {
      this.bindAccountName = bus.global.accountName
      this.bindAccountCode = bus.global.accountCode
    },
    methods: {
      addNext () {
        if (!this.carOwnerName) {
          nError('请输入车主姓名')
          return false
        }
        if (!this.carNumber) {
          nError('请输入车牌号')
          return false
        }
        let obj = {
          carBrand: this.carBrand,
          carColor: this.carColor,
          carOwnerName: this.carOwnerName,
          carOwnerPhone: this.carOwnerPhone,
          enterpriseName: this.enterpriseName,
          carType: this.carType,
          enterStartTime: this.enterStartTime,
          enterEndTime: this.enterEndTime,
          carNumber: this.carNumber,
          cardNumber: this.cardNumber,
          bindAccountName: this.bindAccountName,
          bindAccountCode: this.bindAccountCode,
          bindType: this.bindType,
        }
        this.$axios.post(api.addAuthority, obj)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('添加成功')
              this.personName = ''
              this.cardNumber = ''
              this.carNumber = ''
            }
          })
          .catch(errorHandler('添加失败'))
      },
      add () {
        if (!this.carOwnerName) {
          nError('请输入车主姓名')
          return false
        }
        if (!this.carNumber) {
          nError('请输入车牌号')
          return false
        }
        let obj = {
          carBrand: this.carBrand,
          carColor: this.carColor,
          carOwnerName: this.carOwnerName,
          carOwnerPhone: this.carOwnerPhone,
          enterpriseName: this.enterpriseName,
          carType: this.carType,
          enterStartTime: this.enterStartTime,
          enterEndTime: this.enterEndTime,
          carNumber: this.carNumber,
          cardNumber: this.cardNumber,
          bindAccountName: this.bindAccountName,
          bindAccountCode: this.bindAccountCode,
          bindType: this.bindType,
        }
        this.$axios.post(api.addAuthority, obj)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('添加成功')
              this.strategyCenter()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'authorization-management'
        })
      }
    },
    watch: {
      dataValue (v) {
        this.enterStartTime = v[0]
        this.enterEndTime = v[1]
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/AuthorizationManagement/AuthorizationAdd.vue